<textarea
    matInput
    [required]="to.required"
    [attr.readonly]="to.readonly ? '' : null"
    [placeholder]="to.placeholder"
    [disabled]="to.disabled"
    [attr.maxlength]="to.maxlength"
    [attr.rows]="to.rows"
    [style.height]="to.height"
    [readonly]="to.readonly"
    (change)="onChange($event)"
    #textareaEl>
</textarea>

<ng-content></ng-content>
